module.exports = __webpack_public_path__ + "img/df-wechat.e14d22d1.jpg";